import React from 'react'
import { Icon } from './Birthdate.elements'

type Props = {
  className?: string
}

export const BirthdateIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 14 15"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M3.7 5.474V1.682m3.233 4.445V2.336m3.232 3.138V1.682m-9.05 4.445v5.23c0 1.083 2.604 1.961 5.818 1.961 3.213 0 5.818-.878 5.818-1.96v-5.23c0-1.084-2.604-1.962-5.818-1.962-3.214 0-5.818.878-5.818 1.961z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.115 6.912S1.087 8.32 2.488 8.478c1.402.158 2.226-.671 2.226-.671s.948 1.105 2.514 1.065c1.567-.04 2.267-1.223 2.267-1.223s.618.868 1.69.828c1.072-.039 1.566-1.342 1.566-1.342" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
)
